import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export type PolicyGradient = 'sun' | 'gold' | 'dark' | 'rose' | 'cool' | 'purple' | 'draft';

interface PolicyBadgeThumbProps {
	gradient: PolicyGradient;
	icon?: LucideIcon;
	size?: 'sm' | 'md' | 'lg';
}

const sizePx: Record<NonNullable<PolicyBadgeThumbProps['size']>, number> = { sm: 36, md: 56, lg: 64 };

const gradientClass: Record<Exclude<PolicyGradient, 'draft'>, string> = {
	sun: 'bg-gradient-policy-sun',
	gold: 'bg-gradient-policy-gold',
	dark: 'bg-gradient-policy-dark',
	rose: 'bg-gradient-policy-rose',
	cool: 'bg-gradient-policy-cool',
	purple: 'bg-gradient-policy-purple'
};

/** Gradient + icon badge, shared by the editor head and grid rows. */
export function PolicyBadgeThumb({ gradient, icon: Icon, size = 'md' }: PolicyBadgeThumbProps) {
	const px = sizePx[size];
	const iconPx = Math.round(px * 0.5);
	const style = { width: px, height: px };

	if (gradient === 'draft') {
		return (
			<div style={style} className="flex items-center justify-center rounded-lg border-2 border-dashed border-border-strong">
				{Icon && <Icon size={iconPx} className="text-foreground-disabled" />}
			</div>
		);
	}

	return (
		<div style={style} className={cn('flex items-center justify-center rounded-lg', gradientClass[gradient])}>
			{Icon && <Icon size={iconPx} className="text-white/95" />}
		</div>
	);
}
